import script from "./HamburgerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&setup=true&lang=js"

import "./HamburgerMenu.vue?vue&type=style&index=0&id=072c7ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072c7ea8"]])

export default __exports__